import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--password-visibility"
export default class extends Controller {
  static targets = ["input", "icon"];
  static values = { visible: Boolean };

  connect() {}

  toggle(e) {
    e.preventDefault();

    if (this.visibleValue) {
      this.inputTarget.type = "password";
      this.iconTarget.textContent = "visibility_off";
    } else {
      this.inputTarget.type = "text";
      this.iconTarget.textContent = "visibility";
    }
    this.visibleValue = !this.visibleValue;
  }
}
